import React, { useEffect, useState } from "react";
import { GoogleLogin } from "@react-oauth/google";
import { jwtDecode } from "jwt-decode";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import AOS from "aos";
import "aos/dist/aos.css";
import API_BASE_URL from "../../config/api";
import { useAuth } from "../../context/AuthContext";

function Landing() {
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    const { login } = useAuth();

    const handleLogin = async (e) => {
        e.preventDefault();
        setIsLoading(true);

        try {
            const response = await fetch(`${API_BASE_URL}/api/auth/login`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    userId: document.getElementById("svv-net-id").value,
                    password: document.getElementById("password").value,
                }),
            });

            if (!response.ok) throw new Error();

            const data = await response.json();
            const activeRole = await login(data, data.role);

            toast.success("Login successful!");
            setTimeout(() => navigateByRole(activeRole), 1500);
        } catch {
            toast.error("Login failed");
        } finally {
            setIsLoading(false);
        }
    };

    const handleGoogleSuccess = async (credentialResponse) => {
        try {
            const decoded = jwtDecode(credentialResponse.credential);

            if (!decoded.email.endsWith("@somaiya.edu")) {
                toast.error("Use Somaiya email only");
                return;
            }

            const res = await fetch(`${API_BASE_URL}/api/auth/google-login`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    email: decoded.email,
                    name: decoded.name,
                    token: credentialResponse.credential,
                }),
            });

            const data = await res.json();
            if (!res.ok) throw new Error();

            const activeRole = await login(data, data.role);
            toast.success("Login successful!");
            setTimeout(() => navigateByRole(activeRole), 1500);
        } catch {
            toast.error("Google login failed");
        }
    };

    const navigateByRole = (role) => {
        const map = {
            admin: "/admin/home",
            sa: "/student/home",
            thrustarea: "/thrustarea/home",
            student: "/student/home",
            guide: "/guide/home",
            pc: "/pc/home",
            examiner: "/examiner/home",
        };
        navigate(map[role] || "/");
    };

    useEffect(() => {
        AOS.init({ duration: 800 });
    }, [navigate]);

    return (
        <>
            <ToastContainer />
            <div className="min-h-screen relative grid grid-cols-1 md:grid-cols-2">


                <div className="hidden md:block">
                    <img
                        src="/images/BG-login.jpg"
                        alt="Login"
                        className="h-screen w-full object-cover"
                    />
                </div>

                <div className="flex items-center justify-center bg-[#b7202e] px-4">
                    <div className="w-full max-w-md bg-white rounded-xl shadow-xl p-6 sm:p-8">
                        <div className="flex flex-col items-center mb-6">
                            <img
                                src="https://myaccount.somaiya.edu/img/somaiya-vidyavihar-brand.svg"
                                alt="Somaiya"
                                className="w-32 mb-4"
                            />
                            <h1 className="text-xl sm:text-2xl font-bold text-center text-gray-800">
                                LY Project Allocation Portal
                            </h1>
                        </div>

                        <form onSubmit={handleLogin} className="space-y-4">
                            <div>
                                <label className="block text-sm font-semibold text-gray-600 mb-1">
                                    Login ID
                                </label>
                                <input
                                    id="svv-net-id"
                                    required
                                    className="w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-red-500"
                                    placeholder="Enter Login ID"
                                />
                            </div>

                            <div>
                                <label className="block text-sm font-semibold text-gray-600 mb-1">
                                    Password
                                </label>
                                <input
                                    type="password"
                                    id="password"
                                    required
                                    className="w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-red-500"
                                    placeholder="Enter password"
                                />
                            </div>

                            <button
                                disabled={isLoading}
                                className="w-full py-2.5 bg-blue-600 text-white rounded-md font-semibold hover:bg-blue-700 transition disabled:bg-gray-400"
                            >
                                {isLoading ? "Logging in..." : "Login"}
                            </button>
                        </form>

                        <div className="my-2 text-center text-sm text-gray-500">
                            OR
                        </div>

                        <div className="flex justify-center">
                            <GoogleLogin
                                onSuccess={handleGoogleSuccess}
                                onError={() => toast.error("Login failed")}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Landing;
